import { ICategory } from "web/types/Category";

import getLink from "./getLink";

const redirectToCategory = (categoryObj: ICategory) => {
  switch (true) {
    case categoryObj.url_key === "turystyka-online":
      return getLink("tourism");
    default:
      return getLink(categoryObj.request_path);
  }
};

export default redirectToCategory;
